<template>
  <div :class="{ mobile: isMobile }">
    <FixedHeader
      :header="header"
      :topOnMobile="subheaderTopOnMobile"
      :isAccessibleForAPNICStaff="isAccessibleForAPNICStaff"
    />
    <div
      class="page-content"
      :class="{ 'position-relative': isWithoutBackground }"
    >
      <div class="container ">
        <div
          class="card-wrapper"
          :class="{
            'without-background': isWithoutBackground
          }"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash.throttle';

import FixedHeader from '../ui/FixedHeader';
import mixin from '../../utils/mixin';
import {
  getScrollY,
  getElementHeight,
  getAvailableHeightForScroll
} from '../../utils/BOM';

export default {
  mixins: [mixin],
  props: ['header', 'isWithoutBackground', 'isAccessibleForAPNICStaff'],

  components: {
    FixedHeader
  },
  data() {
    return {
      elementOmnibarHeight: 0,
      elementSubheaderHeight: 0,
      currentScrollY: 0,
      prevScrollY: 0,
      subheaderTopOnMobile: 0
    };
  },
  methods: {
    handleScroll() {
      if (!this.isMobile) return;

      const availableHeightForScroll = getAvailableHeightForScroll();
      if (
        availableHeightForScroll <
        this.elementOmnibarHeight + this.elementSubheaderHeight
      )
        return;

      this.currentScrollY = getScrollY();

      // Check it is scrolling down or scrolling up
      const isScrollingDown = this.currentScrollY - this.prevScrollY > 8;
      const isScrollingUp = this.currentScrollY - this.prevScrollY < -8;

      // Set the top of Subheader as the minus value of its height, i.e. hide it, when scrolling down
      if (
        isScrollingDown &&
        this.currentScrollY >
          this.elementOmnibarHeight + this.elementSubheaderHeight
      ) {
        this.subheaderTopOnMobile = -this.elementSubheaderHeight;
      }

      // Set the top of Subheader as 0, i.e. display it when scrolling up
      if (isScrollingUp && this.subheaderTopOnMobile !== 0) {
        this.subheaderTopOnMobile = 0;
      }

      this.prevScrollY = this.currentScrollY;
    }
  },

  mounted() {
    // Get the height of Omnibar
    const elementOmnibar = document.querySelector('.omnibar');
    if (elementOmnibar)
      this.elementOmnibarHeight = getElementHeight(elementOmnibar);

    // Get the height of Subheader
    const elementSubheader = document.querySelector('.fixed-header');
    if (elementSubheader)
      this.elementSubheaderHeight = getElementHeight(elementSubheader);

    // Throttle scroll handler function
    this.handleThrottledScroll = throttle(this.handleScroll, 200);
    window.addEventListener('scroll', this.handleThrottledScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleThrottledScroll);
  }
};
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #f5f5f7;
  padding: 0.5rem 0;
  min-height: calc(100vh - 6rem);
  position: relative;
  top: 3.75rem;
}
.card-wrapper {
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  padding: 30px 25px;
}
.without-background {
  background-color: initial;
  box-shadow: none;
  padding: 16px 25px;

  @media screen and (max-width: 768px) {
    padding: 8px;
  }
}

.position-relative {
  position: relative;
  min-height: calc(100vh - 40px);
}

.section {
  margin-bottom: 30px;

  ul {
    list-style-type: '- ';
    list-style-position: inside;

    li {
      line-height: 32px;
    }
  }
}
h2 {
  margin-bottom: 10px;
  font-size: 28px;

  @media screen and (max-width: 485px) {
    font-size: 20px;
    line-height: 1.2;
  }
}
p {
  line-height: 1.5;
}

.mobile {
  .page-content {
    top: 0;
  }
}
</style>
